<template>
  <div class="w-full shadow bg-white rounded mb-10">
    <div class="p-4">
      <h3 class="px-3 text-blueGray-600 font-bold">
        {{ elementName.toUpperCase() }} {{ index }}
      </h3>
      <div class="flex flex-wrap mt-4">
        <div
          class="w-full lg:w-4/12 px-4 mt-2"
          v-for="(value, name) in basicAttributes"
          :key="name"
        >
          <div v-if="value.type === 'number'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              ><AttrTitleWithDescription
                :title="formatAttrName(`${name} ${index}`)"
                :description="value.description"
              />
            </label>
            <input
              type="number"
              autocomplete="off"
              data-lpignore="true"
              v-model="formDataLocal[`${name}${index}`]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
          <div
            v-else-if="value.type === 'short_text'"
            class="relative w-full mb-3"
          >
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(`${name} ${index}`)"
                :description="value.description"
              />
            </label>
            <input
              type="text"
              v-model="formDataLocal[`${name}${index}`]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
          <div
            v-else-if="value.type === 'select' || value.type === 'boolean'"
            class="relative w-full mb-3"
          >
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(`${name} ${index}`)"
                :description="value.description"
              />
            </label>
            <select
              v-model="formDataLocal[`${name}${index}`]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            >
              <option
                v-for="(option, index) in changeOptionsFormat(value.options)"
                :key="index"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div v-else-if="value.type === 'url'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(`${name} ${index}`)"
                :description="value.description"
              />
            </label>
            <URLInput
              :url="
                formDataLocal[`${name}${index}`]
                  ? formDataLocal[`${name}${index}`]
                  : ''
              "
              @update:url="(val) => handleUpdateValue(val, name, index)"
            />
          </div>
          <div v-else-if="value.type === 'icon'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(`${name} ${index}`)"
                :description="value.description"
              />
            </label>
            <IconPicker
              :icons="value.options"
              :icon="
                formDataLocal[`${name}${index}`]
                  ? formDataLocal[`${name}${index}`]
                  : ''
              "
              @update:icon="(val) => handleUpdateValue(val, name, index)"
            />
          </div>
          <div v-else class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(`${name} ${index}`)"
                :description="value.description"
              />
            </label>
            <input
              v-model="formDataLocal[`${name}${index}`]"
              type="text"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
      </div>
      <div
        class="w-full px-4 mt-4"
        v-for="(value, name) in additionalAttributes"
        :key="name"
      >
        <div class="relative w-full mb-3">
          <label
            class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            ><AttrTitleWithDescription
              :title="formatAttrName(`${name} ${index}`)"
              :description="value.description"
            />
          </label>
          <ckeditor
            v-if="componentId !== getComponentId('abi_content_block_wrapper')"
            v-model="this.formDataLocal[`${name}${index}`]"
            type="text"
            :editor="editor"
            :config="editorConfig"
            class="h-40 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
          />
          <textarea
            v-else
            type="text"
            class="h-40 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            v-model="this.formDataLocal[`${name}${index}`]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CKEditor from "@ckeditor/ckeditor5-vue";
import * as Constants from "@/store/constants";
import AttrTitleWithDescription from "@/components/Shared/Headers/AttrTitleWithDescription";
import ClassicEditor from "@/assets/ckeditor/build/ckeditor";
import URLInput from "@/components/Shared/Input/URLInput";
import IconPicker from "@/components/Shared/Input/IconPicker";

export default {
  name: "DNElement",
  components: {
    ckeditor: CKEditor.component,
    URLInput,
    IconPicker,
    AttrTitleWithDescription
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: Constants.CK_EDITOR_CONFIG
    };
  },
  props: {
    elementName: {
      type: String,
      required: true
    },
    componentId: {
      type: String,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    dynamicAttributes: {
      type: Object,
      required: true
    }
  },
  computed: {
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    },
    basicAttributes() {
      const result = {};
      Object.keys(this.dynamicAttributes).forEach((item) => {
        if (this.dynamicAttributes[item].type !== "long_text") {
          result[item] = this.dynamicAttributes[item];
        }
      });
      return result;
    },
    additionalAttributes() {
      const result = {};
      Object.keys(this.dynamicAttributes).forEach((item) => {
        if (this.dynamicAttributes[item].type === "long_text") {
          result[item] = this.dynamicAttributes[item];
        }
      });
      return result;
    },
    ...mapGetters(["getAllComponent"])
  },
  methods: {
    getComponentId(name) {
      const foundItem = this.getAllComponent.find((item) => item.name === name);
      if (foundItem) {
        return foundItem.id;
      } else {
        return null;
      }
    },
    handleUpdateValue(val, name, index) {
      this.formDataLocal[`${name}${index}`] = val;
    },
    changeOptionsFormat(options) {
      const newOptions = options.map((item) => {
        return { label: item, value: item };
      });
      return newOptions;
    },
    formatAttrName(name) {
      const nameArray = name.split("_");
      nameArray.splice(0, 2);
      return nameArray.join(" ");
    }
  }
};
</script>
